export enum Ratings {
  A = 5,
  B = 4,
  C = 3,
  D = 2,
  E = 1,
  S = 0,
}
